import {Component, Input, OnInit, ViewChild, ElementRef, HostListener, EventEmitter, Output} from '@angular/core';
import {GameSetUpService} from "../../providers/gameSetUp.service";
import {FinishListService} from "../../providers/finishList.service";



@Component({
    selector: 'order-component',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {


    @Input() teams: any;
    @Output() onOrderChange = new EventEmitter();

    public order: any = [];

    constructor(public gameSetUpService: GameSetUpService) {
    }

    ngOnInit() {
    }






}



// WEBPACK FOOTER //
// ./src/app/components/order/order.component.ts